/** Ограничение бека: 10 МБ на файл */
export const COUNTRY_ATTACHMENT_MAX_SIZE = 10 * 1024 * 1024;

/**
 * Типы, которые принимает бек. Файлы других типов он отбрасывает молча
 * и отвечает 400, только если не прошёл ни один, — поэтому проверяем на клиенте.
 */
const COUNTRY_ATTACHMENT_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
  'application/x-7z-compressed',
  'application/vnd.rar',
  'application/gzip',
  'application/x-tar',
  'image/jpeg',
  'image/png',
  'image/webp',
];

export const COUNTRY_ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.zip,.7z,.rar,.gz,.tar,.jpg,.jpeg,.png,.webp';

/**
 * Проверяет файл перед отправкой.
 * @returns текст ошибки или null, если файл подходит
 */
export const validateCountryAttachment = (file: File): string | null => {
  if (file.size > COUNTRY_ATTACHMENT_MAX_SIZE) return 'File is too large. Maximum size is 10 MB';
  if (!COUNTRY_ATTACHMENT_MIME_TYPES.includes(file.type)) {
    return 'Unsupported file type. Allowed: PDF, DOC, XLS, archives, JPEG, PNG, WebP';
  }

  return null;
};

/** Размер файла в читаемом виде */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Дата последней проверки в локальном формате, либо прочерк */
export const formatCheckedDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString() : '—';
